export const borderRadius = {
  none: 0,
  xs: 4,      // Extra small: scrollbar tracks, tooltips
  sm: 8,      // Small: tags, small buttons, chips
  md: 12,     // Medium: buttons, badges, inputs, toasts
  lg: 16,     // Large: cards, modals, sections
  full: 9999, // Pills, circular avatars
} as const;
